<!-- components/staff/editStaff.vue -->
<template>
  <el-dialog :title="$t('staff.modifyStaff')" :visible.sync="visible" width="50%" @close="handleClose">
    <el-form ref="form" :model="editStaffInfo" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('staff.name')" prop="username">
            <el-input v-model="editStaffInfo.username" :placeholder="$t('staff.requiredName')" />
          </el-form-item>
          <el-form-item :label="$t('email')" prop="email">
            <el-input v-model="editStaffInfo.email" :placeholder="$t('staff.optionalEmail')" />
          </el-form-item>
          <el-form-item :label="$t('staff.phone')" prop="tel">
            <el-input v-model="editStaffInfo.tel" :placeholder="$t('staff.requiredPhone')" />
          </el-form-item>
          <el-form-item :label="$t('staff.gender')" prop="sex">
            <el-select v-model="editStaffInfo.sex" :placeholder="$t('staff.requiredGender')" style="width: 100%">
              <el-option value="0" :label="$t('staff.male')" />
              <el-option value="1" :label="$t('staff.female')" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('staff.relCd')" prop="relCd">
            <el-select v-model="editStaffInfo.relCd" :placeholder="$t('staff.relCdPlaceholder')" style="width: 100%">
              <el-option v-for="(item,index) in editStaffInfo.relCds" :key="index" :label="item.name"
                :value="item.statusCd" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('staff.address')" prop="address">
            <el-input v-model="editStaffInfo.address" :placeholder="$t('staff.requiredAddress')" />
          </el-form-item>
        </el-col>
        <el-col :span="12" style="text-align: center">
          <div class="avatar-uploader" v-if="!editStaffInfo.photoUrl && hasCamera">
            <!-- 摄像头预览 -->
            <video ref="video" autoplay playsinline width="320" height="160"></video>
            <!-- 拍下来的照片预览 -->
            <canvas ref="canvas" style="display: none"></canvas>
          </div>
          <div class="avatar-uploader" v-else>
            <el-image v-if="editStaffInfo.photoUrl" style="width: 200px; height: 150px; border: 1px dashed #ccc"
              :src="editStaffInfo.photoUrl" fit="cover" />
            <el-image v-else style="width: 200px; height: 150px; border: 1px dashed #ccc" src="/img/noPhoto.jpg"
              fit="cover" />
          </div>
          <div style="display: flex; justify-content: center; margin-top: 10px;">
            <el-button type="primary" icon="el-icon-camera" size="small" style="margin-right: 10px" @click="takePhoto"
              v-if="hasCamera">
              {{ $t("addOwnerMember.takePhoto") }}
            </el-button>
            <el-upload :show-file-list="false" :before-upload="beforeUpload" :http-request="uploadImage" action="">
              <el-button size="small" type="primary">
                {{ $t('common.upload') }}
              </el-button>
            </el-upload>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('staff.cancel') }}</el-button>
      <el-button type="primary" @click="editStaffSubmit">{{ $t('staff.edit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { modifyStaff } from '@/api/staff/staffApi'
import { getDict } from '../../api/community/communityApi'
import { uploadImage } from '@/api/owner/ownerApi'


export default {
  name: 'EditStaff',
  props: {
    staffInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      editStaffInfo: {
        userId: '',
        username: '',
        email: '',
        tel: '',
        sex: '',
        address: '',
        photo: '',
        photoUrl: '',
        relCd: '',
        relCds: [],
        branchOrgs: [],
        departmentOrgs: [],
        parentOrgId: '',
        parentOrgName: '',
        parentTwoOrgId: '',
        orgNewName: '',
        orgId: ''
      },
      stream: null, // 摄像头视频流
      hasCamera: false, // 是否支持摄像头
    }
  },
  watch: {
    staffInfo: {
      immediate: true,
      handler(val) {
        if (val) {
          this.editStaffInfo = {
            ...val,
            username: val.name,
          }
        }
      }
    }
  },
  methods: {
    // 初始化摄像头
    async startCamera() {
      try {
        // 基础兼容性判断
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.$message && this.$message.error("当前浏览器不支持摄像头调用");
          return;
        }

        // 先检测当前设备是否存在摄像头
        if (!navigator.mediaDevices.enumerateDevices) {
          // 某些非常老的浏览器没有 enumerateDevices，只能直接尝试 getUserMedia
          this.$message && this.$message.warning("无法检测摄像头设备，直接尝试打开摄像头");
        } else {
          const devices = await navigator.mediaDevices.enumerateDevices();
          const hasCamera = devices.some((d) => d.kind === "videoinput");

          if (!hasCamera) {
            // this.$message && this.$message.error("未检测到摄像头设备");
            this.hasCamera = false;
            return;
          }
        }

        // 注意：video 在 template 里被 v-if 控制，必须等 DOM 渲染出来再取 ref。
        // 第一次可能因为权限弹窗很慢“刚好没问题”，第二次 getUserMedia 很快就会踩到这里。
        this.hasCamera = true;
        await this.$nextTick();

        // 请求摄像头权限（可根据需求设置前后摄像头）
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" }, // 前置可用 'user'
          audio: false,
        });

        const video = this.$refs.video;
        if (!video) {
          // 理论上不应发生：兜底避免抛 TypeError 被当成“权限/设备问题”。
          console.warn("video ref 未就绪，无法挂载摄像头流");
          return;
        }

        if ("srcObject" in video) {
          video.srcObject = this.stream;
        } else {
          // 旧浏览器兼容
          video.src = window.URL.createObjectURL(this.stream);
        }
        video.play();
      } catch (err) {
        console.error("打开摄像头失败", err);

        // 根据错误类型给更友好的提示
        if (err.name === "NotFoundError" || err.name === "OverconstrainedError") {
          this.$message && this.$message.error("未检测到可用的摄像头");
        } else if (err.name === "NotAllowedError" || err.name === "SecurityError") {
          this.$message && this.$message.error("摄像头权限被拒绝，请在浏览器中开启权限");
        } else {
          this.$message && this.$message.error("打开摄像头失败，请检查设备和权限");
        }
      }
    },
    stopCamera() {
      // 1. 停止所有 track
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }

      // 2. 清理 video
      const video = this.$refs.video;
      if (video) {
        if ("srcObject" in video) {
          video.srcObject = null;
        } else {
          video.src = "";
        }
        video.pause && video.pause();
      }
    },
    // 拍照 / 重新拍照
    takePhoto() {
      // 若当前已经有照片：点击“拍照”= 重新拍照（清空旧图 -> 展示预览 -> 重启摄像头）
      if (this.editStaffInfo.photoUrl) {
        if (!this.hasCamera) return;

        this.editStaffInfo.photo = "";
        this.editStaffInfo.photoUrl = "";

        // 允许重复选择同一文件（上传照片后也可再选同一张）
        if (this.$refs.fileInput) this.$refs.fileInput.value = "";

        // 先停再启，避免部分浏览器占用摄像头导致 getUserMedia 失败
        this.stopCamera();
        this.$nextTick(() => this.startCamera());
        return;
      }

      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      if (!video || !canvas) return;

      const vw = video.videoWidth;
      const vh = video.videoHeight;
      if (!vw || !vh) {
        console.warn("无法获取视频分辨率");
        return;
      }

      const maxSize = 1080; // 限制最大宽高

      // 计算等比例缩放比例，保证宽高都不超过 1080
      const scale = Math.min(maxSize / vw, maxSize / vh, 1);

      const targetW = Math.round(vw * scale);
      const targetH = Math.round(vh * scale);

      // 设置 canvas 的内部绘制尺寸（真实图片尺寸）
      canvas.width = targetW;
      canvas.height = targetH;

      const ctx = canvas.getContext("2d");
      // 把当前视频帧画到指定大小
      ctx.drawImage(video, 0, 0, targetW, targetH);

      // 转成 Blob
      canvas.toBlob(
        (blob) => {
          if (!blob) return;
          // 如果 _doUploadImage 需要 File：
          const file = new File([blob], "photo.jpg", { type: "image/jpeg" });
          this.uploadImage({file});
          this.stopCamera(); // 拍照后停止摄像头
        },
        "image/jpeg",
        0.8
      );
    },
    open(row) {
      let _url =  '/img/noPhoto.jpg'
      if(row.urls && row.urls.length > 0){
        _url = row.urls[0]
      }
      this.editStaffInfo = {
        ...row,
        username: row.name,
        photo: _url
      }
      this.editStaffInfo.photoUrl = row.photoUrl || '/img/noPhoto.jpg'
      console.log(this.editStaffInfo.photoUrl)
      this.getRelCd()
      this.visible = true
      this.$nextTick(async () => {
        await this.startCamera();
      });
    },
    async getRelCd() {
      const data = await getDict('u_org_staff_rel', "rel_cd")
      this.editStaffInfo.relCds = data
      this.$forceUpdate()
    },
    handleClose() {
      this.visible = false
      this.stopCamera()
    },
    validateForm() {
      if (!this.editStaffInfo.username) {
        this.$message.error(this.$t('staff.requiredName'))
        return false
      }
      if (!this.editStaffInfo.tel) {
        this.$message.error(this.$t('staff.requiredPhone'))
        return false
      }
      if (this.editStaffInfo.sex === '') {
        this.$message.error(this.$t('staff.requiredGender'))
        return false
      }
      if (!this.editStaffInfo.address) {
        this.$message.error(this.$t('staff.requiredAddress'))
        return false
      }
      return true
    },
    async editStaffSubmit() {
      if (!this.validateForm()) return

      try {
        this.loading = true
        const data = {
          ...this.editStaffInfo,
          name: this.editStaffInfo.username,
          staffId: this.editStaffInfo.userId
        }

        await modifyStaff(data)
        this.visible = false
        this.$message.success(this.$t('common.operationSuccess'))
        this.$emit('success')
        this.handleClose()
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error(this.$t('common.jpgOnly'))
      }
      if (!isLt2M) {
        this.$message.error(this.$t('common.sizeLimit'))
      }
      return isJPG && isLt2M
    },
    async uploadImage({ file }) {
      try {
        const res = await uploadImage({ file })
        this.editStaffInfo.photo = res.fileId
        this.editStaffInfo.photoUrl = res.url
        this.$forceUpdate()
      } catch (error) {
        this.$message.error(this.$t('listOwner.upload.failed'))
      }
    },
  }
}
</script>
